import restaurantModalLoginInstance from '../../../modalLoginInstance'
import restaurantInstance from '../../../instance'

const printTableSplit = (splitId, tableId, data, hasModalLogin = true) => {
  return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
    .post(`/tables/${tableId}/splits/${splitId}/print`, data)
}

export default printTableSplit
